<template>
  <div class="texteditpop" ref="textPop" :style="{left: `${x}px`, top: `${y}px`}">
    <el-input
    ref="texteditinput"
    :disabled="disabled"
  type="textarea"
  resize="none"
  :rows="10"
  placeholder="请输入内容"
  v-model="textarea"
    :title="textarea">
</el-input>
<!-- <el-button type="primary" @click="handleConfirm">确定</el-button>
<el-button @click="handleClose">关闭</el-button> -->
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean, // sync
      default: false
    },
    rect: {
      type: Object,
      default: () => {}
    },
    column: {
      type: Object,
      default: () => {}
    },
    scope: {
      type: Object,
      default: () => {}
    },
    textarea: {
      type: String,
      default: ''
    }
  },
  data() {
    const {
      disabled
    } = this.column
    const {
      x,
      y,
      width
    } = this.rect
    return {
      disabled,
      x,
      y,
      width
    }
  },
  watch: {

  },
  mounted() {
    const bottomH = document.body.clientHeight - 240
    if (bottomH < this.y) {
      this.y = bottomH - 20
    }
    this.$nextTick(() => {
      const body = document.querySelector('body')
      if (body.append) {
        body.append(this.$el)
      } else {
        body.appendChild(this.$el)
      }
      this.$refs.texteditinput.focus()
    })

    document.addEventListener('click', (e) => {
      if (this.$refs.textPop) {
        const boxRect = this.$refs.textPop.getBoundingClientRect()
        const targetRect = e.target.getBoundingClientRect()
        console.log(document.getElementsByClassName('texteditpop')[0] === this.$refs.textPop)
        const {
          x,
          y
        } = targetRect
        const isX = x >= boxRect.x && x <= boxRect.x + boxRect.width
        const isY = y >= boxRect.y && y <= boxRect.y + boxRect.height
        // console.log(isY, isX, targetRect, boxRect)
        if (!(isX && isY)) {
          this.handleConfirm()
        }
      }
    })
  },
  methods: {
    handleClose() {
      this.$emit('update:isOpen', false)
    },
    handleConfirm() {
      this.$emit('on-edit', this.textarea)
      this.handleClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.texteditpop {
  position: fixed;
  left: 0;
  top: 0;
  width: 300px;
  z-index: 2001;
  background-color: #fff;
}
</style>
